import {MessageBox} from "element-ui";
import router from "@/router";
/**
 * 弹窗确认去实名认值
 * @param realNameState {number}  实名认证状态 -1 未认证 1：已提交相关资料，审核中 2：认证失败 3：已认证
 * @param actionName {string}  操作名称
 */
export function confirmGoRealName(realNameState,actionName="收藏"){
  let message = "您还未通过实名认证，请先实名认证。";
  let confirmBtnText = "去认证";
  if(realNameState === -1){

  }else if(realNameState === 1){
    message = `您提交的实名认证资料正在审核中，请耐心等待。`;
    confirmBtnText = "去查看";
  }else if(realNameState === 2){
    message = `您提交的实名认证资料审核未通过，请重新提交。`;
  }
  return MessageBox({
    title:"提示",
    message:message,
    confirmButtonText: confirmBtnText,
    lockScroll:false,
  }).then(() => {
    if(realNameState !== 3) router.push({
      path: "/placeOrder/supplierJoin",
    })
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.realName.js